import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button, Card, Icon, Loader, Message } from "semantic-ui-react";

import { OpenAPI } from "simplydo/interfaces";

import { useAppSelector } from "store";

import IdeaCardView from "components/lib/Ideas/IdeaView/IdeaCardView";
import { EmptyBox } from "components/lib/UI";

type ProfileIdeasProps = {
  ideas: OpenAPI.Assign<
    OpenAPI.Schemas["Idea"],
    OpenAPI.Schemas["AssignIdeaTags"],
    OpenAPI.Schemas["AssignIdeaChallenges"]
  >[];
  loading: boolean;
  filter: string;
  sort: string;
  showDraft: boolean;
  showSubmitted: boolean;
  profileUser: OpenAPI.Schemas["User"];
};

const ProfileIdeas = ({
  ideas = [],
  loading,
  filter,
  sort,
  showDraft,
  showSubmitted,
  profileUser,
}: ProfileIdeasProps) => {
  const { t } = useTranslation();
  const user = useAppSelector((state) => state.user);

  const filteredIdeas = ideas.filter((idea) => {
    if (!showDraft && !idea.isSubmitted) return false;
    if (!showSubmitted && idea.isSubmitted) return false;
    if (
      idea.ownerTags?.find((fullTag) =>
        fullTag.value.match(RegExp(filter, "i")),
      )
    )
      return true;
    if (idea.name?.match(RegExp(filter, "i"))) return true;
    if (idea.ownerChallenge?.name.includes(filter)) return true;
    return false;
  });
  if (sort === "oldest") filteredIdeas.reverse();
  if (loading) return <Loader active inline="centered" />;
  if (!loading && !filteredIdeas.length && !ideas.length) {
    return (
      <EmptyBox>
        <h2>
          {t(
            user?._id === profileUser?._id ?
              "ideas.yours.sidebar.noneCreated"
            : "ideas.others.noneCreated",
            { user: profileUser?.profile?.fullName },
          )}
        </h2>
        <Button
          as={Link}
          to="/challenges/discover"
          primary
          basic
          icon="plus"
          content={t("challenges.discover.title")}
        />
      </EmptyBox>
    );
  }
  if (!loading && !filteredIdeas.length && ideas.length > 0) {
    return <EmptyBox title="This user has no public ideas available" />;
  }
  return (
    <div style={{ marginBottom: 20 }}>
      {profileUser._id === user._id && (
        <div style={{ marginBottom: 15 }}>
          <Message>{t("users.profile.ideas.admins")}</Message>
        </div>
      )}
      <Card.Group itemsPerRow={3} stackable>
        {filteredIdeas.map((idea) => (
          <IdeaCardView
            key={idea._id}
            idea={idea}
            challenge={idea.ownerChallenge}
            ideasVotedFor={0}
          />
        ))}
      </Card.Group>
    </div>
  );
};

export default ProfileIdeas;
